import { SetStateAction, useCallback, useEffect, useState } from 'react';
import Pagination from './Pagination';

interface TableProps {
  tableItems: any;
}

let headers: string[] = [];

function NormalCase(casing: string | any[]) {
  let result: string;
  let finalResult: string;
  for (const item of casing) {
    const result = item
      .replace(/([A-Z]+)/g, ' $1')
      .replace(/([A-Z][a-z])/g, '$1')
      .replace(/_/g, ' ');

    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);

    headers.push(finalResult);
  }
}

export const Table = ({ tableItems }: TableProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(100);

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  // Get current page
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRow = tableItems.slice(indexOfFirstRow, indexOfLastRow);

  //Change page
  const paginate = useCallback((pageNumber: SetStateAction<number>) => {
    setCurrentPage(pageNumber);
  }, []);
  const headersList = headers;
  headers = [];
  let headerNames: any[] = [];
  if (tableItems[0] != undefined) {
    headerNames = Object.keys(tableItems[0]);
  }
  {
    NormalCase(headerNames);
  }
  return (
    <div className="table-responsive responsive-table">
      <table className="table table-striped">
        <thead>
          <tr className="header-names">
            <th className="header-elements">#</th>
            {headersList.map((item) => (
              <th key={item} className="header-elements">
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentRow.map((item: any, index: any) => (
            <>
              <tr key={item} className="each-row">
                <>
                  <td className="row-elements">{index + 1 + (currentPage - 1) * 100}</td>
                  <>
                    {headerNames.map((entry: any, index: any) => (
                      <td key={item} className="row-elements">
                        {item[entry]}
                      </td>
                    ))}
                  </>
                </>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      <div>
        <Pagination
          postsPerPage={rowsPerPage}
          totalPosts={tableItems.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};
